import { organizationsAuditListDef } from '../../../../backend/features/organizations/shared';
import { requireAnySystemPermission, requireOrgPermission } from '../../../../backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
export const organizationsAuditList = implementTypedPlatformFunction(organizationsAuditListDef, (context, request) => {
    const hasOrgViewHistorySystemPermission = requireAnySystemPermission(context.userState, 'view-organization-history');
    let hasViewHistoryOrgPermission = false;
    if (request.entitiesList) {
        hasViewHistoryOrgPermission = request.entitiesList.every((org) => { var _a; return (_a = org.entityIds) === null || _a === void 0 ? void 0 : _a.every((orgId) => requireOrgPermission(context.userState, orgId, 'view-organization-history')); });
    }
    if (hasOrgViewHistorySystemPermission || hasViewHistoryOrgPermission) {
        return context.audit.list(request);
    }
    throw new AuthError('Unauthorized');
});
